import { render } from "./recapTransCompta.vue?vue&type=template&id=2583a4fc&scoped=true"
import script from "./recapTransCompta.vue?vue&type=script&lang=js"
export * from "./recapTransCompta.vue?vue&type=script&lang=js"

import "./recapTransCompta.vue?vue&type=style&index=0&id=2583a4fc&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2583a4fc"]])

export default __exports__